import React from 'react';
import { EmptyState } from '../../../../components/EmptyState';
import GenerateButton from '../GenerateButton';

export default function ListPageEmptyState(props: { disabled: boolean }) {
  const disabled: boolean = props.disabled ?? false;
  return (
    <div className='app-card shadow-sm align-items-center mt-3 p-3 p-xxl-3'>
      <EmptyState
        title='No API Keys created yet'
        text='You haven’t generated any API keys yet. Create your first key to start connecting your application or service.'
        cardless={true}
        actionButton={
          <div className='mt-4'>
            <GenerateButton disabled={disabled} />
          </div>
        }
      />
    </div>
  );
}
